var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { BreadCrumb, Button, Dialog, Divider, InputTextarea, OverlayPanel, Tag, Typography, } from "@uigovpe/components";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useCallback, useEffect, useMemo, useRef, useState, } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getAttachmentsByConsultation, } from "../../../apis/attachments";
import { createComment, createSupport, deleteComment, deleteSupport, listComments, updateComment, } from "../../../apis/comments";
import { getConsultationById, patchConsultation, } from "../../../apis/consultations";
import { getMyContributions, } from "../../../apis/contributions";
import { getApiErrorMessage } from "../../../apis/http";
import { useAuth } from "../../auth/AuthContext";
import { CommentsThread } from "../components/CommentsThread";
import { ConsultationFileButton, readFileSizeFromMetadata, } from "../components/ConsultationFileButton";
import { ConsultationFormPreview } from "../components/ConsultationFormPreview";
import { SectionDivider } from "../components/SectionDivider";
import { capitalizeSentence, formatDate, truncateText, } from "../utils/formatters";
import { buildUserSupportsMap, findContributionBySource, sortConsultationItems, } from "../utils/participation";
import { buildPublicPdfPreviewUrl, normalizePublicFileUrl, } from "../utils/publicFileUrl";
var STATUS_VIEW = {
    active: { label: "Ativa", severity: "success" },
    canceled: { label: "Cancelada", severity: "danger" },
    closed: { label: "Fechada", severity: "info" },
    finished: { label: "Encerrada", severity: "info" },
    planned: { label: "Planejada", severity: "info" },
    published: { label: "Publicada", severity: "warning" },
};
var pageStyle = {
    display: "grid",
    gap: 16,
    padding: "16px 12px 32px",
    width: "100%",
};
var topGridStyle = {
    alignItems: "start",
    display: "grid",
    gap: 16,
};
var summaryStyle = {
    display: "grid",
    gap: 16,
};
var detailsCardStyle = {
    border: "1px solid #E5E7EB",
    borderRadius: 8,
    display: "grid",
    gap: 8,
    padding: 16,
};
var contentBlockStyle = {
    display: "grid",
    gap: 16,
};
var feedbackStyles = {
    error: { background: "#FFE4E4", color: "#7A1F1F" },
    info: { background: "#E6F3FF", color: "#0B4F8C" },
    success: { background: "#EAFBD7", color: "#245C15" },
    warning: { background: "#FFF7D6", color: "#7A5800" },
};
var noteBoxStyle = {
    background: "#E6F3FF",
    borderRadius: 12,
    display: "grid",
    gap: 8,
    marginBottom: 24,
    padding: 16,
};
var iframeStyle = {
    border: "1px solid #CBD5E1",
    borderRadius: 8,
    minHeight: 520,
    width: "100%",
};
var getHomePathByRole = function (role) {
    return "/";
};
var FeedbackBox = function (_a) {
    var message = _a.message, severity = _a.severity;
    return (_jsx("div", __assign({ style: __assign(__assign({}, feedbackStyles[severity]), { borderRadius: 12, padding: "12px 16px" }) }, { children: _jsx(Typography, { children: message }) })));
};
export var ConsultationDetailsPage = function () {
    var _a, _b, _c, _d;
    var slug = useParams().slug;
    var consultationId = Number(slug);
    var hasValidConsultationId = Number.isFinite(consultationId) && consultationId > 0;
    var isDesktop = useMediaQuery("(min-width: 960px)");
    var navigate = useNavigate();
    var actionsOverlayRef = useRef(null);
    var _e = useAuth(), accessToken = _e.accessToken, hasToken = _e.hasToken, isAuthenticated = _e.isAuthenticated, role = _e.role, user = _e.user;
    var _f = useState([]), attachments = _f[0], setAttachments = _f[1];
    var _g = useState(false), cancelDialogOpen = _g[0], setCancelDialogOpen = _g[1];
    var _h = useState(""), commentValue = _h[0], setCommentValue = _h[1];
    var _j = useState([]), comments = _j[0], setComments = _j[1];
    var _k = useState(null), commentsError = _k[0], setCommentsError = _k[1];
    var _l = useState(false), commentsLoading = _l[0], setCommentsLoading = _l[1];
    var _m = useState(null), consultation = _m[0], setConsultation = _m[1];
    var _o = useState(null), feedback = _o[0], setFeedback = _o[1];
    var _p = useState(false), finishDialogOpen = _p[0], setFinishDialogOpen = _p[1];
    var _q = useState(true), loading = _q[0], setLoading = _q[1];
    var _r = useState(false), managingStatus = _r[0], setManagingStatus = _r[1];
    var _s = useState(false), myContributionLoading = _s[0], setMyContributionLoading = _s[1];
    var _t = useState([]), myContributions = _t[0], setMyContributions = _t[1];
    var _u = useState(null), pageError = _u[0], setPageError = _u[1];
    var _v = useState(null), editalPreviewUrl = _v[0], setEditalPreviewUrl = _v[1];
    var _w = useState(false), sendingRootComment = _w[0], setSendingRootComment = _w[1];
    var _x = useState({}), supportOverrides = _x[0], setSupportOverrides = _x[1];
    var loadComments = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!hasValidConsultationId) {
                        return [2 /*return*/];
                    }
                    setCommentsLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, listComments(consultationId, {
                            direction: "DESC",
                            limit: 250,
                            page: 0,
                        }, accessToken)];
                case 2:
                    response = _a.sent();
                    setComments(response.data.comments || []);
                    setCommentsError(null);
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _a.sent();
                    setCommentsError(getApiErrorMessage(error_1));
                    return [3 /*break*/, 5];
                case 4:
                    setCommentsLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); }, [accessToken, consultationId, hasValidConsultationId]);
    var loadMyContributions = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!accessToken || !hasValidConsultationId) {
                        setMyContributions([]);
                        return [2 /*return*/];
                    }
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, 4, 5]);
                    setMyContributionLoading(true);
                    return [4 /*yield*/, getMyContributions(accessToken)];
                case 2:
                    response = _b.sent();
                    setMyContributions((response.data.contributions || []).filter(function (entry) { return entry.contribution.consultationId === consultationId; }));
                    return [3 /*break*/, 5];
                case 3:
                    _a = _b.sent();
                    setMyContributions([]);
                    return [3 /*break*/, 5];
                case 4:
                    setMyContributionLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); }, [accessToken, consultationId, hasValidConsultationId]);
    useEffect(function () {
        if (!hasValidConsultationId) {
            setPageError("Consulta inválida.");
            setLoading(false);
            return;
        }
        var isMounted = true;
        var loadPage = function () { return __awaiter(void 0, void 0, void 0, function () {
            var _a, consultationResponse, attachmentsResponse, error_2;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        setLoading(true);
                        setPageError(null);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, Promise.all([
                                getConsultationById(consultationId, accessToken),
                                getAttachmentsByConsultation(consultationId),
                            ])];
                    case 2:
                        _a = _b.sent(), consultationResponse = _a[0], attachmentsResponse = _a[1];
                        if (!isMounted) {
                            return [2 /*return*/];
                        }
                        setConsultation(consultationResponse.data.consultation);
                        setAttachments(attachmentsResponse.data.attachments || []);
                        return [3 /*break*/, 5];
                    case 3:
                        error_2 = _b.sent();
                        if (!isMounted) {
                            return [2 /*return*/];
                        }
                        setPageError(getApiErrorMessage(error_2));
                        return [3 /*break*/, 5];
                    case 4:
                        if (isMounted) {
                            setLoading(false);
                        }
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        void loadPage();
        void loadComments();
        return function () {
            isMounted = false;
        };
    }, [accessToken, consultationId, hasValidConsultationId, loadComments]);
    useEffect(function () {
        void loadMyContributions();
    }, [loadMyContributions]);
    useEffect(function () {
        setSupportOverrides({});
    }, [consultationId]);
    var homePath = getHomePathByRole(role);
    var statusView = consultation
        ? STATUS_VIEW[consultation.status]
        : STATUS_VIEW.planned;
    var items = useMemo(function () { return sortConsultationItems(consultation === null || consultation === void 0 ? void 0 : consultation.consultationItems); }, [consultation === null || consultation === void 0 ? void 0 : consultation.consultationItems]);
    var editalAttachment = attachments.find(function (attachment) { return attachment.edital; });
    var extraAttachments = attachments.filter(function (attachment) { return !attachment.edital; });
    var hasAnsweredForm = Boolean(findContributionBySource(myContributions, consultationId, "form"));
    var baseUserSupports = useMemo(function () { return buildUserSupportsMap(myContributions, consultationId, comments); }, [comments, consultationId, myContributions]);
    var userSupports = useMemo(function () {
        var mergedSupports = __assign({}, baseUserSupports);
        Object.entries(supportOverrides).forEach(function (_a) {
            var commentId = _a[0], supportId = _a[1];
            var normalizedCommentId = Number(commentId);
            if (supportId === null) {
                delete mergedSupports[normalizedCommentId];
                return;
            }
            mergedSupports[normalizedCommentId] = supportId;
        });
        return mergedSupports;
    }, [baseUserSupports, supportOverrides]);
    var isManagerMode = role === "agency_manager" || role === "admin_scge";
    var canShowCommentsSection = isAuthenticated &&
        (consultation === null || consultation === void 0 ? void 0 : consultation.status) === "active" &&
        (consultation.type === "with_form" ||
            (consultation.type === "without_form" && role !== "citizen"));
    var canShowCommentInput = isAuthenticated &&
        role === "citizen" &&
        (consultation === null || consultation === void 0 ? void 0 : consultation.status) === "active" &&
        consultation.type === "with_form";
    var canManageConsultation = Boolean(isManagerMode && consultation);
    var canEditOrCancel = canManageConsultation &&
        Boolean(consultation &&
            ["planned", "active", "published"].includes(consultation.status));
    var canFinish = canManageConsultation && Boolean((consultation === null || consultation === void 0 ? void 0 : consultation.status) === "closed");
    var handleActionError = useCallback(function (error) {
        setFeedback({
            message: getApiErrorMessage(error),
            severity: "error",
        });
    }, []);
    var handleOpenAttachment = useCallback(function (attachment) {
        var fileUrl = normalizePublicFileUrl(attachment.path);
        if (!fileUrl) {
            setFeedback({
                message: "Arquivo sem URL para visualizacao.",
                severity: "error",
            });
            return;
        }
        window.open(fileUrl, "_blank", "noopener,noreferrer");
    }, []);
    useEffect(function () {
        if (!editalAttachment ||
            !consultation ||
            consultation.status !== "planned") {
            setEditalPreviewUrl(null);
            return;
        }
        setEditalPreviewUrl(buildPublicPdfPreviewUrl(editalAttachment.path));
    }, [consultation, editalAttachment]);
    var handleSendRootComment = function () { return __awaiter(void 0, void 0, void 0, function () {
        var error_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!consultation || !accessToken || !commentValue.trim()) {
                        return [2 /*return*/];
                    }
                    setSendingRootComment(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, 5, 6]);
                    return [4 /*yield*/, createComment(consultation.id, { content: commentValue.trim() }, accessToken)];
                case 2:
                    _a.sent();
                    return [4 /*yield*/, loadComments()];
                case 3:
                    _a.sent();
                    setCommentValue("");
                    setFeedback({
                        message: "Comentário enviado!",
                        severity: "success",
                    });
                    return [3 /*break*/, 6];
                case 4:
                    error_3 = _a.sent();
                    handleActionError(error_3);
                    return [3 /*break*/, 6];
                case 5:
                    setSendingRootComment(false);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var handleSubmitReply = function (parentCommentId, content) { return __awaiter(void 0, void 0, void 0, function () {
        var error_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!consultation || !accessToken) {
                        return [2 /*return*/];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, createComment(consultation.id, {
                            content: content,
                            parentCommentId: parentCommentId,
                        }, accessToken)];
                case 2:
                    _a.sent();
                    return [4 /*yield*/, loadComments()];
                case 3:
                    _a.sent();
                    setFeedback({
                        message: "Resposta enviada!",
                        severity: "success",
                    });
                    return [3 /*break*/, 5];
                case 4:
                    error_4 = _a.sent();
                    handleActionError(error_4);
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var handleUpdateComment = function (commentId, content) { return __awaiter(void 0, void 0, void 0, function () {
        var error_5;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!consultation || !accessToken) {
                        return [2 /*return*/];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, updateComment(consultation.id, commentId, { content: content }, accessToken)];
                case 2:
                    _a.sent();
                    return [4 /*yield*/, loadComments()];
                case 3:
                    _a.sent();
                    setFeedback({
                        message: "Comentário atualizado!",
                        severity: "success",
                    });
                    return [3 /*break*/, 5];
                case 4:
                    error_5 = _a.sent();
                    handleActionError(error_5);
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var handleDeleteComment = function (commentId) { return __awaiter(void 0, void 0, void 0, function () {
        var error_6;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!consultation || !accessToken) {
                        return [2 /*return*/];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, deleteComment(consultation.id, commentId, accessToken)];
                case 2:
                    _a.sent();
                    return [4 /*yield*/, loadComments()];
                case 3:
                    _a.sent();
                    setFeedback({
                        message: "Comentário excluído!",
                        severity: "success",
                    });
                    return [3 /*break*/, 5];
                case 4:
                    error_6 = _a.sent();
                    handleActionError(error_6);
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var handleAddSupport = function (commentId) { return __awaiter(void 0, void 0, void 0, function () {
        var response_1, error_7;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!consultation || !accessToken) {
                        return [2 /*return*/];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, createSupport(consultation.id, commentId, accessToken)];
                case 2:
                    response_1 = _a.sent();
                    setSupportOverrides(function (currentValue) {
                        var _a;
                        return (__assign(__assign({}, currentValue), (_a = {}, _a[commentId] = response_1.data.support.id, _a)));
                    });
                    return [4 /*yield*/, Promise.all([loadComments(), loadMyContributions()])];
                case 3:
                    _a.sent();
                    setFeedback({
                        message: "Apoio adicionado!",
                        severity: "success",
                    });
                    return [3 /*break*/, 5];
                case 4:
                    error_7 = _a.sent();
                    handleActionError(error_7);
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var handleRemoveSupport = function (commentId, supportId) { return __awaiter(void 0, void 0, void 0, function () {
        var error_8;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!consultation || !accessToken) {
                        return [2 /*return*/];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, deleteSupport(consultation.id, commentId, supportId, accessToken)];
                case 2:
                    _a.sent();
                    setSupportOverrides(function (currentValue) {
                        var _a;
                        return (__assign(__assign({}, currentValue), (_a = {}, _a[commentId] = null, _a)));
                    });
                    return [4 /*yield*/, Promise.all([loadComments(), loadMyContributions()])];
                case 3:
                    _a.sent();
                    setFeedback({
                        message: "Apoio removido!",
                        severity: "success",
                    });
                    return [3 /*break*/, 5];
                case 4:
                    error_8 = _a.sent();
                    handleActionError(error_8);
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var handleStatusChange = function (status) { return __awaiter(void 0, void 0, void 0, function () {
        var error_9;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!consultation || !accessToken) {
                        return [2 /*return*/];
                    }
                    setManagingStatus(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, patchConsultation(consultation.id, { status: status }, accessToken)];
                case 2:
                    _a.sent();
                    setFeedback({
                        message: status === "canceled"
                            ? "Consulta cancelada com sucesso!"
                            : "Consulta encerrada com sucesso!",
                        severity: "success",
                    });
                    navigate(homePath);
                    return [3 /*break*/, 5];
                case 3:
                    error_9 = _a.sent();
                    handleActionError(error_9);
                    return [3 /*break*/, 5];
                case 4:
                    setManagingStatus(false);
                    setCancelDialogOpen(false);
                    setFinishDialogOpen(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs("div", __assign({ style: pageStyle }, { children: [_jsx(BreadCrumb, { home: { command: function () { return navigate(homePath); }, label: "Início" }, model: [
                    {
                        label: truncateText(capitalizeSentence((_a = consultation === null || consultation === void 0 ? void 0 : consultation.title) !== null && _a !== void 0 ? _a : "Carregando..."), 30),
                    },
                ] }), feedback ? _jsx(FeedbackBox, __assign({}, feedback)) : null, loading ? (_jsx(Typography, { children: "Carregando..." })) : pageError || !consultation ? (_jsxs("div", __assign({ style: contentBlockStyle }, { children: [_jsx(FeedbackBox, { message: pageError || "Consulta não encontrada.", severity: "error" }), _jsx("div", { children: _jsx(Button, { label: "Voltar para consultas", onClick: function () { return navigate("/"); } }) })] }))) : (_jsxs(_Fragment, { children: [_jsxs("div", __assign({ style: __assign(__assign({}, topGridStyle), { gridTemplateColumns: isDesktop
                                ? "minmax(0, 1fr) minmax(280px, 340px)"
                                : "1fr" }) }, { children: [_jsxs("div", __assign({ style: summaryStyle }, { children: [_jsx(Typography, __assign({ fontWeight: "bold", size: "lg" }, { children: consultation.title })), _jsxs("div", __assign({ style: contentBlockStyle }, { children: [_jsx(Typography, { children: consultation.description }), _jsxs(Typography, { children: ["Per\u00EDodo:", " ", _jsxs("strong", { children: [formatDate(consultation.startDate), " -", " ", formatDate(consultation.endDate)] })] })] }))] })), _jsxs("div", __assign({ style: detailsCardStyle }, { children: [_jsxs("div", __assign({ style: {
                                            alignItems: "center",
                                            display: "flex",
                                            justifyContent: "space-between",
                                        } }, { children: [_jsx(Typography, __assign({ size: "sm", style: { color: "#6B7280" } }, { children: "Detalhes" })), canManageConsultation ? (_jsxs(_Fragment, { children: [_jsx(Button, { label: "A\u00E7\u00F5es", onClick: function (event) { var _a; return (_a = actionsOverlayRef.current) === null || _a === void 0 ? void 0 : _a.toggle(event); }, severity: "secondary" }), _jsx(OverlayPanel, __assign({ dismissable: true, ref: actionsOverlayRef }, { children: _jsxs("div", __assign({ style: { display: "grid", minWidth: 220 } }, { children: [_jsx("button", __assign({ onClick: function () {
                                                                        var _a;
                                                                        if (!canEditOrCancel) {
                                                                            return;
                                                                        }
                                                                        (_a = actionsOverlayRef.current) === null || _a === void 0 ? void 0 : _a.hide();
                                                                        navigate("/edit-consultation/".concat(consultation.id));
                                                                    }, style: {
                                                                        background: "transparent",
                                                                        border: "none",
                                                                        cursor: canEditOrCancel ? "pointer" : "not-allowed",
                                                                        opacity: canEditOrCancel ? 1 : 0.5,
                                                                        padding: "12px 0",
                                                                        textAlign: "left",
                                                                    }, type: "button" }, { children: canEditOrCancel
                                                                        ? "Editar consulta"
                                                                        : "Não é possível editar" })), _jsx(Divider, {}), _jsx("button", __assign({ onClick: function () {
                                                                        var _a;
                                                                        if (!canEditOrCancel) {
                                                                            return;
                                                                        }
                                                                        (_a = actionsOverlayRef.current) === null || _a === void 0 ? void 0 : _a.hide();
                                                                        setCancelDialogOpen(true);
                                                                    }, style: {
                                                                        background: "transparent",
                                                                        border: "none",
                                                                        color: canEditOrCancel ? "#C01616" : "#6B7280",
                                                                        cursor: canEditOrCancel ? "pointer" : "not-allowed",
                                                                        opacity: canEditOrCancel ? 1 : 0.5,
                                                                        padding: "12px 0",
                                                                        textAlign: "left",
                                                                    }, type: "button" }, { children: canEditOrCancel
                                                                        ? "Cancelar consulta"
                                                                        : "Não é possível cancelar" })), _jsx(Divider, {}), _jsx("button", __assign({ onClick: function () {
                                                                        var _a;
                                                                        if (!canFinish) {
                                                                            return;
                                                                        }
                                                                        (_a = actionsOverlayRef.current) === null || _a === void 0 ? void 0 : _a.hide();
                                                                        setFinishDialogOpen(true);
                                                                    }, style: {
                                                                        background: "transparent",
                                                                        border: "none",
                                                                        color: canFinish ? "#C01616" : "#6B7280",
                                                                        cursor: canFinish ? "pointer" : "not-allowed",
                                                                        opacity: canFinish ? 1 : 0.5,
                                                                        padding: "12px 0",
                                                                        textAlign: "left",
                                                                    }, type: "button" }, { children: canFinish
                                                                        ? "Encerrar consulta"
                                                                        : "Não é possível encerrar" }))] })) }))] })) : null] })), _jsxs(Typography, __assign({ size: "sm" }, { children: [_jsx("strong", { children: "\u00D3rg\u00E3o:" }), " ", capitalizeSentence(((_b = consultation.agency) === null || _b === void 0 ? void 0 : _b.name) || "—")] })), _jsxs(Typography, __assign({ size: "sm" }, { children: [_jsx("strong", { children: "Tema:" }), " ", capitalizeSentence(truncateText(((_c = consultation.theme) === null || _c === void 0 ? void 0 : _c.name) || "—", 30))] })), _jsxs(Typography, __assign({ size: "sm" }, { children: [_jsx("strong", { children: "Munic\u00EDpio:" }), " ", consultation.municipio || "—"] })), _jsxs("div", __assign({ style: { alignItems: "center", display: "flex", gap: 8 } }, { children: [_jsx(Typography, __assign({ size: "sm" }, { children: _jsx("strong", { children: "Status:" }) })), _jsx(Tag, { severity: statusView.severity, value: statusView.label })] })), _jsxs(Typography, __assign({ size: "sm" }, { children: [_jsx("strong", { children: "Abertura:" }), " ", formatDate(consultation.startDate)] })), _jsxs(Typography, __assign({ size: "sm" }, { children: [_jsx("strong", { children: "Fechamento:" }), " ", formatDate(consultation.endDate)] })), _jsxs(Typography, __assign({ size: "sm" }, { children: [_jsx("strong", { children: "Contribui\u00E7\u00F5es:" }), " ", (_d = consultation.totalContributions) !== null && _d !== void 0 ? _d : "—"] })), editalAttachment ? (_jsxs("div", __assign({ style: { display: "grid", gap: 8 } }, { children: [_jsx(Typography, __assign({ size: "sm" }, { children: _jsx("strong", { children: "Edital:" }) })), _jsx(ConsultationFileButton, { fileName: editalAttachment.fileName || "", fileSizeBytes: readFileSizeFromMetadata(editalAttachment.metadata), onOpen: function () { return handleOpenAttachment(editalAttachment); } })] }))) : null] }))] })), _jsx(SectionDivider, { children: "Anexos" }), extraAttachments.length > 0 ? (_jsx("div", __assign({ style: { display: "grid", gap: 12, maxWidth: 420 } }, { children: extraAttachments.map(function (attachment) { return (_jsx(ConsultationFileButton, { fileName: attachment.fileName || "", fileSizeBytes: readFileSizeFromMetadata(attachment.metadata), onOpen: function () { return handleOpenAttachment(attachment); } }, attachment.id)); }) }))) : (_jsx(Typography, __assign({ size: "sm" }, { children: "Nenhum anexo enviado ainda." }))), consultation.status !== "planned" &&
                        consultation.status !== "canceled" ? (_jsxs(_Fragment, { children: [_jsx(SectionDivider, { children: "Question\u00E1rio" }), _jsx(ConsultationFormPreview, { consultationId: consultation.id, consultationItems: items, consultationStatus: consultation.status, hasAnsweredForm: hasAnsweredForm, hasToken: hasToken, isAuthenticated: isAuthenticated, isManagerMode: isManagerMode, myContributionLoading: myContributionLoading, openQuestion: consultation.type === "without_form"
                                    ? consultation.description
                                    : undefined, typeForm: consultation.type })] })) : null, canShowCommentsSection ? (_jsxs(_Fragment, { children: [_jsx(SectionDivider, { children: "Coment\u00E1rios" }), _jsxs("div", __assign({ style: noteBoxStyle }, { children: [_jsx(Typography, __assign({ fontWeight: "bold", size: "sm" }, { children: "Obs.:" })), _jsx(Typography, __assign({ size: "sm" }, { children: "Os coment\u00E1rios s\u00E3o um espa\u00E7o para di\u00E1logo e troca de opini\u00F5es entre os cidad\u00E3os. Eles n\u00E3o s\u00E3o considerados contribui\u00E7\u00F5es oficiais e n\u00E3o entram na an\u00E1lise dos resultados da consulta." })), _jsx(Typography, __assign({ size: "sm" }, { children: "Para que sua participa\u00E7\u00E3o seja registrada como contribui\u00E7\u00E3o, \u00E9 necess\u00E1rio responder \u00E0s perguntas ou preencher os formul\u00E1rios da consulta. Somente essas respostas s\u00E3o contabilizadas." }))] })), _jsxs("div", __assign({ style: contentBlockStyle }, { children: [canShowCommentInput ? (_jsxs("div", __assign({ style: { display: "grid", gap: 16 } }, { children: [_jsx(InputTextarea, { label: "Deixe um coment\u00E1rio", onChange: function (event) {
                                                    return setCommentValue(event.target.value);
                                                }, placeholder: "Digite", rows: 6, value: commentValue }), _jsxs("div", __assign({ style: {
                                                    display: "flex",
                                                    gap: 16,
                                                    justifyContent: "flex-end",
                                                } }, { children: [_jsx(Button, { label: "Cancelar", link: true, onClick: function () { return setCommentValue(""); }, size: "small" }), _jsx(Button, { disabled: sendingRootComment || !commentValue.trim(), label: sendingRootComment ? "Enviando..." : "Enviar", onClick: function () { return void handleSendRootComment(); }, size: "small" })] }))] }))) : null, commentsLoading ? (_jsx(Typography, { children: "Carregando coment\u00E1rios..." })) : commentsError ? (_jsx(FeedbackBox, { message: commentsError, severity: "error" })) : (_jsx(CommentsThread, { comments: comments, currentUserId: user === null || user === void 0 ? void 0 : user.id, currentUserRole: role, onAddSupport: handleAddSupport, onDeleteComment: handleDeleteComment, onRemoveSupport: handleRemoveSupport, onSubmitReply: handleSubmitReply, onUpdateComment: handleUpdateComment, userSupports: userSupports }))] }))] })) : null, consultation.status === "planned" &&
                        editalAttachment &&
                        editalPreviewUrl ? (_jsxs(_Fragment, { children: [_jsx(SectionDivider, { children: "Edital" }), _jsx("iframe", { src: editalPreviewUrl, style: iframeStyle, title: editalAttachment.fileName })] })) : null] })), _jsx(Dialog, __assign({ header: "Cancelar consulta", onHide: function () { return setCancelDialogOpen(false); }, style: { maxWidth: 480, width: "90vw" }, visible: cancelDialogOpen }, { children: _jsxs("div", __assign({ style: { display: "grid", gap: 16 } }, { children: [_jsx(Typography, { children: "Tem certeza que deseja cancelar esta consulta?" }), _jsxs("div", __assign({ style: {
                                display: "flex",
                                gap: 8,
                                justifyContent: "space-between",
                            } }, { children: [_jsx(Button, { label: "Voltar", onClick: function () { return setCancelDialogOpen(false); }, severity: "secondary" }), _jsx(Button, { disabled: managingStatus, label: managingStatus ? "Cancelando..." : "Cancelar", onClick: function () { return void handleStatusChange("canceled"); }, severity: "danger" })] }))] })) })), _jsx(Dialog, __assign({ header: "Encerrar consulta", onHide: function () { return setFinishDialogOpen(false); }, style: { maxWidth: 480, width: "90vw" }, visible: finishDialogOpen }, { children: _jsxs("div", __assign({ style: { display: "grid", gap: 16 } }, { children: [_jsx(Typography, { children: "Tem certeza que deseja encerrar esta consulta?" }), _jsxs("div", __assign({ style: {
                                display: "flex",
                                gap: 8,
                                justifyContent: "space-between",
                            } }, { children: [_jsx(Button, { label: "Voltar", onClick: function () { return setFinishDialogOpen(false); }, severity: "secondary" }), _jsx(Button, { disabled: managingStatus, label: managingStatus ? "Encerrando..." : "Encerrar", onClick: function () { return void handleStatusChange("finished"); }, severity: "danger" })] }))] })) }))] })));
};
